import React from 'react'
import PartyLozenge from '../../Helpers/PartyLozenge'
import Party from '../../../models/Party'
import CoalitionsListBody from './CoalitionsListBody'
import { ICoalitionCount } from '../../../models/OutcomeController'

interface IProps {
  coalitionCounts: ICoalitionCount
  numCoalitionResults: number
  totalNumOutcomes: number
  header: string
}

export const lozenges = (partyKey: string): JSX.Element => {
  const lozengeKeys =
    partyKey.indexOf('-') > -1 ? partyKey.split('-') : [partyKey]

  return (
    <React.Fragment>
      {lozengeKeys.map(
        (key: string, index: number): JSX.Element => (
          <PartyLozenge
            small={index > 0}
            className="mr-2"
            key={key}
            party={Party.fromKey(key)}
          />
        )
      )}
    </React.Fragment>
  )
}

class CoalitionsList extends React.Component<IProps> {
  public render(): JSX.Element {
    const { coalitionCounts, header, numCoalitionResults } = this.props

    console.log('coalitionCounts', coalitionCounts)

    return (
      <React.Fragment>
        <h4>{header}</h4>
        <table className="table">
          <tbody>
            {coalitionCounts && Object.keys(coalitionCounts).length > 0 ? (
              <React.Fragment>
                <tr>
                  <td colSpan={2}>
                    <p className="text-muted mb-0">
                      Each row in this table represents the possibility that the
                      given combination of parties would be able to form a
                      coalition government (&ge; 170 seats), across all{' '}
                      {numCoalitionResults} minority situations.
                    </p>
                  </td>
                </tr>
                <CoalitionsListBody
                  coalitionCounts={coalitionCounts}
                  numCoalitionResults={numCoalitionResults}
                />
              </React.Fragment>
            ) : (
              <tr>
                <td>No outcomes.</td>
              </tr>
            )}
          </tbody>
        </table>
      </React.Fragment>
    )
  }
}

export default CoalitionsList
